import type { App } from "@upsquad/server";
import type { UpdateProfilePayload } from "@upsquad/shared";
import type { EdenCall } from "@/src/common/lib/eden-base-query";
import { baseApi } from "@/src/common/services/base-api";

type UpdateProfileResponse = App["~Routes"]["user"]["profile"]["patch"]["response"]["200"];
type CheckSlugResponse = App["~Routes"]["community"]["check-slug"][":slug"]["get"]["response"]["200"];
type JoinCommunityResponse = App["~Routes"]["community"]["by-slug"][":slug"]["join"]["post"]["response"]["200"];

export const onboardingApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		updateOnboardingProfile: builder.mutation<UpdateProfileResponse, UpdateProfilePayload>({
			query:
				(payload): EdenCall<UpdateProfileResponse> =>
				(client) =>
					client.user.profile.patch(payload),
		}),
		checkSlug: builder.query<CheckSlugResponse, string>({
			query:
				(slug): EdenCall<CheckSlugResponse> =>
				(client) =>
					client.community["check-slug"]({ slug }).get(),
		}),
		joinCommunity: builder.mutation<JoinCommunityResponse, string>({
			query:
				(slug): EdenCall<JoinCommunityResponse> =>
				(client) =>
					client.community["by-slug"]({ slug }).join.post({}),
		}),
	}),
});

export const { useUpdateOnboardingProfileMutation, useCheckSlugQuery, useLazyCheckSlugQuery, useJoinCommunityMutation } = onboardingApi;
